//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "exportExcel",
  data: function data() {
    return {
      isIndeterminate: true,
      checkAll: false,
      checkedCars: [],
      isShowDialog: false
    };
  },
  props: {
    carTitles: {
      type: Array,
      default: []
    },
    url: {
      type: String,
      default: ""
    },
    map: {
      type: Object,
      default: {}
    },
    fileName: {
      type: String,
      default: ''
    }
  },
  methods: {
    showDiolag: function showDiolag() {
      var self = this;
      self.isShowDialog = true;
      self.checkedCars = [];
    },
    exportExcel: function exportExcel() {
      var self = this;
      self.isShowDialog = false;
      var params = JSON.parse(JSON.stringify(this.map));
      this.$emit('handle-params', params);
      Lib.M.ajax({
        'method': "post",
        'url': self.url,
        'data': params,
        'responseType': "blob",
        'success': function success(data) {
          ;
          var fileName = self.fileName + ".xlsx";
          var blob = new Blob([data]);
          var elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          console.log(elink.href);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        },
        "error": function error(data) {
          self.$message({
            message: "下载失败",
            type: "warning"
          });
        }
      });
    },
    submit: function submit() {
      this.exportExcel();
    },
    changeTransfer: function changeTransfer(val) {
      this.map.excelTitle = JSON.stringify(val);
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCars = val ? this.carTitles : [];
      this.isIndeterminate = false;
      this.$emit("getExcelTitle", val ? this.checkedCars : []);
    },
    handleCheckedCarsMsgChange: function handleCheckedCarsMsgChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.carTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.carTitles.length;
      this.$emit("getExcelTitle", value);
    }
  }
};